export default __webpack_public_path__ + "static/media/experiences_hero.2f751748.mp4";